import type { ChatPromptContextEntityType } from '@flux/iara-core/prompt-context';

/**
 * Título de boas-vindas por tipo de entidade em foco.
 *
 * Fica no client, e não na fonte única do contexto, porque é concordância de
 * gênero em português — apresentação, não contrato. Sendo um `Record` exaustivo,
 * acrescentar uma entidade na lib quebra a compilação aqui até alguém escrever a
 * frase, em vez de cair num texto genérico sem ninguém notar.
 */
export const IARA_WELCOME_TITLE: Record<ChatPromptContextEntityType, string> = {
  approval: 'Pergunte sobre esta aprovação',
  card: 'Pergunte sobre este card',
  database: 'Pergunte sobre esta base',
  pipe: 'Pergunte sobre este fluxo',
  screen: 'Pergunte sobre esta tela',
  stage: 'Pergunte sobre esta etapa',
  task: 'Pergunte sobre esta tarefa',
};

/** Sem entidade em foco, a pergunta é aberta. */
export const IARA_WELCOME_TITLE_FALLBACK = 'O que você quer saber?';
